/**
 *  群发详情弹出框
 *  by lzy 2018-04-24
 */
"use strict";
angular.module("weixinShowMassSendModule", []).controller("weixinShowMassSendController", ["$scope", "draftParams", "$modalInstance", "trsconfirm", "trsHttpService", "$q",
    function($scope, draftParams, $modalInstance, trsconfirm, trsHttpService, $q) {
        initData();

        /**
         * [initData description]
         * @return {[type]} [description]
         */
        function initData() {
            $scope.data = {
                docIds: draftParams.items.SENDINGORDER,
                massArray: [],
                sendTo: "全部"
            };
            requestData($scope.data.docIds);
        }

        function requestData(docIds) {
            var params = {
                serviceid: "mlf_wechatgroupsend",
                methodname: "findDocDetails",
                DocIds: docIds
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                $scope.data.massArray = data;
            });
        }
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }
]);